import { YENI_TASARIM } from './yeniTasarim';

/*
  ONAY SORUSU ("Emin misiniz?")

  Canli sistemde tarayicinin kendi onay kutusu (window.confirm) acilir --
  davranis eskisiyle birebir ayni. Yeni tasarimda bunun yerine iPhone
  tarzi sade bir pencere acilir (components/Common/OnayPenceresi.js).

  Kullanim:  if (!(await onayla('Bu belge silinsin mi?', { onay: 'Sil', tehlikeli: true }))) return;
*/
let pencereHazir = false;
export const onayPenceresiHazir = (v) => { pencereHazir = v; };

/* Secenek verilmediyse sorunun kendisinden anlasilir: silme/kaldirma
   sorularinda onay dugmesi kirmizi "Sil" / "Kaldir" olur. */
const sorudanSecenek = (mesaj) => {
  const m = String(mesaj || '');
  if (/silmek|silinsin|silinecek|sileceksiniz|\bsil\b/i.test(m)) return { onay: 'Sil', tehlikeli: true };
  if (/kaldırmak|kaldırılsın|kaldırılacak/i.test(m)) return { onay: 'Kaldır', tehlikeli: true };
  if (/reddetmek|reddedilsin/i.test(m)) return { onay: 'Reddet', tehlikeli: true };
  return {};
};

export const onayla = (mesaj, secenek = {}) => {
  if (!YENI_TASARIM || !pencereHazir) {
    return Promise.resolve(window.confirm(mesaj));
  }
  return new Promise((resolve) => {
    window.dispatchEvent(new CustomEvent('onay-iste', {
      detail: { mesaj, ...sorudanSecenek(mesaj), ...secenek, resolve },
    }));
  });
};

export default onayla;
